/**
 * This file contains functions which provide a nice way to report an alert
 *
 * @author Learning Technologies, 51cg
 * @copyright Learning Technologies, 51cg
 */

window.Alert = {
    /**
     * Create an Alert
     *
     * Creates and returns an alert jQuery object that can then be used with either the show or hide methods.
     *
     * @param {String} title   Alert title
     * @param {String} message Alert body
     * @param {String} type    Alert type
     *
     * @return {Object}
     */
    create: function (title, message, type) {
        var iconType;
        var icon = '';
        var self = this;

        if (type == 'success') {
            iconType = 'regular';
            icon     = 'check-circle';
        } else if (type == 'danger') {
            iconType = 'regular';
            icon     = 'circle-xmark';
        } else if (type == 'info') {
            iconType = 'solid';
            icon     = 'info-circle';
        } else {
            iconType = 'solid';
            icon     = 'exclamation-circle';
        }

        if (title === undefined) {
            title = '';
        }
        if (message === undefined) {
            message = '';
        }

        var alert = $('<div class="alert alert-block alert-' + type + '"><button class="close" type="button"><i class="' + FontAwesome.prefix('solid', 'xmark') + '"></i></button><h3 class="text-' + type + '"><i class="' + FontAwesome.prefix(iconType, icon) + '"></i> ' + title + '</h3> <p class="text-' + type + '">' + message + '</p></div>').hide();

        alert.on('click', 'button.close', function () {
            self.dismiss(alert);
        });

        return alert;
    },

    /**
     * Display the alert specified by the jQuery object passed in
     *
     * @param {Object}        alert     A jQuery object representing the alert object to display
     * @param {Number}        timeout   The number of ms after which the alert should auto-dismisis. Set to 0 to never auto-dismiss
     * @param {String|Object} container The element to display the alert in (optional). Defaults to #alertscontainer if not set
     *
     * @return {Object}
     */
    show: function (alert, timeout, container) {
        var self = this;

        if (container === undefined) {
            container = $('#alertscontainer');
        }

        if (timeout === undefined) {
            timeout = 3000;
        }

        if (timeout > 0) {
            setTimeout(function () {
                self.dismiss(alert);
            }, timeout);
        }

        $(container).append(alert);

        alert.show('fade');

        return alert;
    },

    /**
     * Dismiss the alert specified by the jQuery object passed in
     *
     * @param {Object} alert_reference A jQuery object representing the alert to be dismissed
     *
     * @return {Object}
     */
    dismiss: function (alert_reference) {
        alert_reference.hide('fade', function () {
            $(this).remove();
        });
    },

    /**
     * Display a success alert
     *
     * @param {String}        title     Alert title
     * @param {String}        message   Alert body
     * @param {Number}        timeout   The number of ms after which the alert should auto-dismisis. Set to 0 to never auto-dismiss
     * @param {String|Object} container The element to display the alert in (optional). Defaults to #alertscontainer if not set
     *
     * @return {Object}
     */
    success: function (title, message, timeout, container) {
        return this.show(this.create(title, message, 'success'), timeout, container);
    },

    /**
     * Display a failure alert
     *
     * @param {String}        title     Alert title
     * @param {String}        message   Alert body
     * @param {Number}        timeout   The number of ms after which the alert should auto-dismisis. Set to 0 to never auto-dismiss
     * @param {String|Object} container The element to display the alert in (optional). Defaults to #alertscontainer if not set
     *
     * @return {Object}
     */
    error: function (title, message, timeout, container) {
        if (timeout === undefined) {
            timeout = 0;
        }
        return this.show(this.create(title, message, 'danger'), timeout, container);
    },

    /**
     * Display an info alert
     *
     * @param {String}        title     Alert title
     * @param {String}        message   Alert body
     * @param {Number}        timeout   The number of ms after which the alert should auto-dismisis. Set to 0 to never auto-dismiss
     * @param {String|Object} container The element to display the alert in (optional). Defaults to #alertscontainer if not set
     *
     * @return {Object}
     */
    info: function (title, message, timeout, container) {
        return this.show(this.create(title, message, 'info'), timeout, container);
    },

    /**
     * Display an warning alert
     *
     * @param {String}        title     Alert title
     * @param {String}        message   Alert body
     * @param {Number}        timeout   The number of ms after which the alert should auto-dismisis. Set to 0 to never auto-dismiss
     * @param {String|Object} container The element to display the alert in (optional). Defaults to #alertscontainer if not set
     *
     * @return {Object}
     */
    warn: function (title, message, timeout, container) {
        return this.show(this.create(title, message, 'warning'), timeout, container);
    },
};
